import React, {Component} from 'react';
import {Button, Form, Input, Segment, TextArea, Search,Header} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import { DropzoneComponent } from 'react-dropzone-component';

const uuidv1 = require('uuid/v1');


class AddNewAlarm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            alarmLocation: undefined,
            alarmExpiry:undefined,
            alarmDesc: undefined,
            alarmName: undefined,
            id: undefined,
            file: undefined,
            images: undefined
        }
    }

    handleSubmit = () => {
        this.setState({isCreating:true});
        const inspectionType = this.props.reportDetails['inspection_type'];
        let alarmObj = {};
        setTimeout(() => {
            if (inspectionType !== 'co') {
                alarmObj = {
                    action: 'create',
                    name: this.state.alarmName,
                    client_id: uuidv1(),
                    ci_description: this.state.alarmDesc,
                    ci_location: this.state.alarmLocation,
                    ci_expiry:this.state.alarmExpiry,
                    ci_image: this.state.images
                };
            }
            else {
                alarmObj = {
                    action: 'create',
                    client_id: uuidv1(),
                    name: this.state.alarmName,
                    co_description: this.state.alarmDesc,
                    co_location: this.state.alarmLocation,
                    co_expiry:this.state.alarmExpiry,
                    co_image: this.state.images
                };
            }
            this.props.addNewAlarm(alarmObj);
            // this.refs.alarmName.inputRef.value = '';
           // this.refs.alarmLoc.inputRef.value = '';
            // this.refs.alarmDesc.ref.value = '';
            // this.refs.alarmExpiry.inputRef.value = '';
            // this.refs.alarmImage.inputRef.value = '';
            this.setState({alarmLocation: undefined,alarmDesc: undefined, alarmName: undefined, expiry:undefined,images:undefined,isCreating:false});
        }, 1000);
    };

    handleFile = (file) => {
        let fr = new FileReader();
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                const Image = {
                    id: uuidv1(),
                    file: file
                };
                this.setState({images: Image});
            };
            fr.readAsDataURL(file);
        }
    };

    removingFile = () => {
        this.setState({images: undefined});
    };
    render() {
        
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpeg, image/png, image/gif",
            maxFiles: 1
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
            },
            addedfile: (file) => {
                    this.removingFile(file)  
                    if(file.type.startsWith("image/")){
                        this.handleFile(file)
                        this.setState({imageError:false})
                    }
                    else {
                        this.setState({imageError:true})
                    }
            },
            maxfilesexceeded: function (files) {
                this.removeAllFiles();
                this.addFile(files);
         },

            removedfile: (file) => {
                this.removingFile(file)                   
            },
            // complete: function(file) {
            //       this.removeFile(file); // right here after 3 seconds you can clear
            //   },
        };
        
       
        

        const inspectionType = this.props.reportDetails['inspection_type'];
        return (<div className={"responsive-width-alarm"}
                     style={{paddingLeft: '0',margin:"auto",marginTop:"15px"}}>
            <Segment>
                  <Header content="Add New Alarm" color="teal" textAlign='center'/>
                <Form onSubmit={this.handleSubmit}>
                    <div style={{padding: "0 1%"}}>
                        <Form.Field>
                            <label>Alarm Name</label>
                            <Search
                                    placeholder='Alarm Name'
                                    ref="alarmName"
                                    required
                                    results={ [{
                                        "title": "Smoke Alarm"
                                      },{
                                        "title": "Carbon Alarm"
                                    },{
                                        "title": "Heat Alarm"
                                    },{
                                        "title": "ONLY TYPE FREELY IF STRICTLY NECESSARY"
                                    }]}
                                    value={this.state.alarmName||""} 
                                    onSearchChange={(e,data) => { this.setState({ alarmName: data.value })}} 
                                    onResultSelect={(e,data) => { this.setState({ alarmName: data.result.title })}} 
                                    />
                        </Form.Field>
                        <Form.Field>
                            <label>Alarm Location</label>
                            <Input
                                type="text"
                                placeholder="Alarm Location"
                                required
                                ref="alarmLoc"
                                onFocus={(e) => {
                                    this.setState({alarmLocation: e.target.value});
                                }}
                                onChange={(e) => {
                                    this.setState({alarmLocation: e.target.value});
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Alarm Expiry Date</label>
                            <Input
                                type="text"
                                placeholder="Alarm Expiry Date"
                                required
                                ref="alarmExpiry"
                                onFocus={(e) => {
                                    this.setState({alarmExpiry: e.target.value});
                                }}
                                onChange={(e) => {
                                    this.setState({alarmExpiry: e.target.value});
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Alarm Description</label>
                                <Search
                                    placeholder='Alarm Description'
                                    required
                                    results={ [{
                                        "title": "Tested and Audible"
                                      },{
                                        "title": "Not Audible"
                                    },{
                                        "title": "Not Tested"
                                    },{
                                        "title": "ONLY TYPE FREELY IF STRICTLY NECESSARY"
                                    }]}
                                    value={this.state.alarmDesc|| ""} 
                                    onSearchChange={(e,data) => { this.setState({ alarmDesc: data.value })}} 
                                    onResultSelect={(e,data) => { this.setState({ alarmDesc: data.result.title })}} 
                                    />
                            {/* <TextArea
                                type="textarea"
                                placeholder="Alarm Description "
                                required
                                ref="alarmDesc"
                                onFocus={(e) => {
                                    this.setState({alarmDesc: e.target.value});
                                }}
                                onChange={(e) => {
                                    this.setState({alarmDesc: e.target.value});
                                }}
                            /> */}
                        </Form.Field>
                        {/* <Form.Field>
                            <Input ref="alarmImage" type="file" onChange={(e) => {
                                this.handleFile(e.target.files[0])
                            }}/>
                        </Form.Field> */}
                        <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }} eventHandlers={eventHandlers} djsConfig={djsConfig}/>
                    <div style={{marginTop:"15px", textAlign:"center"}}>
                        <Button type="submit" content="Add New Alarm" primary disabled={this.state.isCreating}/></div>
                    </div>
                </Form>
            </Segment></div>);
    }
}

export default ReportContainer(AddNewAlarm);


// WEBPACK FOOTER //
// ./src/views/report/add_new_alarm.js